import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";

import {
	NotificationsInfo,
	NotificationsInfoRequest,
	OmsMessage,
	OmsMessageStatus,
	OmsService,
	OmsUserSettings,
	UpdateMessage,
} from "../oms.model";

@Injectable()
export class NoopOmsService implements OmsService {
	getNotificationsByStatus(_state: OmsMessageStatus): Observable<OmsMessage[]> {
		return EMPTY;
	}

	updateMessage(_updateMessage: UpdateMessage): Observable<unknown> {
		return EMPTY;
	}

	updateMessages(_updateMessages: UpdateMessage[]): Observable<unknown> {
		return EMPTY;
	}

	getAlerts(_context: string): Observable<OmsMessage[]> {
		return EMPTY;
	}

	getNotificationsInfo(_notificationInfoParams: NotificationsInfoRequest): Observable<NotificationsInfo> {
		return EMPTY;
	}

	getUserSettings(): Observable<OmsUserSettings> {
		return EMPTY;
	}

	updateUserSettings(_userSettings: OmsUserSettings): Observable<OmsUserSettings> {
		return EMPTY;
	}
}
